import React from 'react'

import {
  fundsCheckDescriptiveDate,
  getHistoryForCurrentUser,
} from '@apiEnabler/ob-common/lib/funds-check-consents'
import PaymentAccountId from '@apiEnabler/ob-common/lib/view/PaymentAccountId'
import DateTimeWarning from '@apiEnabler/ob-common/lib/view/DateTimeWarning'

import ConsentOverviewHeader from './ConsentOverviewHeader'
import NavBar, { NavItem } from './NavBar'
import HistoryCard from './HistoryCard'

import style from './FundsCheckOverview.module.css'
import textStyle from '../common/api-enabler-styles.module.css'

export default function FundsCheckOverview({
  fundsCheck,
  tpp,
  onCancel,
  isStaffMember,
}) {
  const { label, date, getDescriptionText } =
    fundsCheckDescriptiveDate(fundsCheck)
  const handleCancel = createCancelHandler(fundsCheck, onCancel)
  return (
    <section className={`${style.content} js-funds-check-overview`}>
      <NavBar
        items={[
          new NavItem({ label: 'Funds Checks', link: '/funds-checks/tpps' }),
          new NavItem({
            label: tpp.get('clientDisplayName'),
            link: `/funds-checks/tpps/${tpp.get('clientId')}/funds-checks`,
          }),
        ]}
        padded
      />

      <ConsentOverviewHeader
        dateLabel={label}
        dateValue={date}
        description={getDescriptionText(tpp.get('clientDisplayName'))}
        onCancel={handleCancel}
        cancelLabel="Cancel permission"
        consentStatus={fundsCheck.get('status')}
      />
      <div className={style.section}>
        <h2 className={style.sectionHeading}>Details</h2>
        <div
          className={`${style.sectionContent} zb-card js-funds-check-account-card`}
        >
          <div className={style.cardBody}>
            <div
              className={`${style.accountName} ${textStyle.moduleTitle} ob-brand-colour js-name-text`}
            >
              {fundsCheck.getIn([
                'payload',
                'account',
                'account',
                'customerName',
              ])}
            </div>

            <PaymentAccountId
              accountId={fundsCheck.getIn(['payload', 'account'])}
              className="zb-dark-grey-2"
            />
          </div>
        </div>
      </div>
      <div className={style.section}>
        <h2 className={style.sectionHeading}>History</h2>
        <div className={`${style.sectionContent} zb-card`}>
          {getHistoryForCurrentUser(fundsCheck, isStaffMember).map(
            (record, i) => (
              <HistoryCard
                key={i}
                className={`js-history-card-${i}`}
                history={record}
                showIcon={false}
              />
            )
          )}
        </div>
      </div>
      <DateTimeWarning />
    </section>
  )
}

function createCancelHandler(fundsCheck, onCancel) {
  if (onCancel && fundsCheck.get('grouping') === 'ACTIVE') {
    return () => {
      onCancel(fundsCheck)
    }
  }
  return null
}
